export enum BracePosition {
  Back = 'back',
  Front = 'front',
  Middle = 'middle',
}
